"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.toSnakeCase = exports.toCamelCase = exports.objectToQueryString = exports.objectToBodyString = void 0;
/**
 * Transforms snakecase strings to camelcase.
 *
 * @param {String} string The string you want to transform to camelcase.
 */
const toCamelCase = function () {
  let string = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : '';
  return string.replace(/_([a-z])/g, firstLetter => firstLetter[1].toUpperCase());
};

/**
 * Transforms camelcase strings to snakecase.
 *
 * @param {String} string The string you want to transform to snakecase.
 */
exports.toCamelCase = toCamelCase;
const toSnakeCase = function () {
  let string = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : '';
  return string.replace(/([A-Z])/g, firstLetter => `_${firstLetter.toLowerCase()}`);
};

/**
 * Transforms a set of params into an API body string.
 *
 * @param {Object} params The parameters you wish to include in an API body.
 * @returns an API body string containing all the provided params.
 */
exports.toSnakeCase = toSnakeCase;
const objectToBodyString = params => {
  if (Boolean(params) && typeof params === 'object') {
    return Object.keys(params).map(key => {
      var _params$key;
      return (_params$key = params[key]) !== null && _params$key !== void 0 && _params$key.length || typeof params[key] === 'boolean' ? `${encodeURIComponent(key)}=${encodeURIComponent(params[key])}` : '';
    }).filter(item => item !== '').join('&');
  }
  return '';
};

/**
 * Transforms a set of params into an API query string.
 *
 * @param {Object} params The parameters you wish to include in an API query.
 * @returns an API query string containing all the provided params.
 */
exports.objectToBodyString = objectToBodyString;
const objectToQueryString = params => {
  let bodyString = '';
  if (params && typeof params === 'object') {
    bodyString = Object.keys(params).map(key => {
      var _params$key2;
      return (_params$key2 = params[key]) !== null && _params$key2 !== void 0 && _params$key2.length || typeof params[key] === 'boolean' ? `${encodeURIComponent(key)}=${encodeURIComponent(params[key])}` : '';
    }).filter(item => item !== '').join('&');
  }
  if (bodyString.length) {
    return `?${bodyString}`;
  }
  return '';
};
exports.objectToQueryString = objectToQueryString;